import { h, ref } from 'vue'
import Notification from '@/components/Notification.vue'

export default function (app) {
  const toastRef = ref(null)

  // Componente wrapper do Notification.vue
  const NotificationWrapper = {
    name: 'NotificationWrapper',
    setup() {
      return () => h(Notification, { ref: toastRef })
    },
  }

  // Função interna para exibir toast
  const showToast = (msg, color = 'primary', timeout = 4000) => {
    toastRef.value?.show(msg, color, timeout)
  }

  // Objeto global com métodos específicos
  const notification = {
    success: (msg, timeout = 4000) => showToast(msg, 'success', timeout),
    error: (msg, timeout = 4000) => showToast(msg, 'error', timeout),
    info: (msg, timeout = 4000) => showToast(msg, 'info', timeout),
    warning: (msg, timeout = 4000) => showToast(msg, 'warning', timeout),
  }

  // Registro global
  app.config.globalProperties.$notification = notification
  window.notification = notification

  // Componente que renderiza na tela
  app.component('NotificationWrapper', NotificationWrapper)
}
